import { useSelector } from "react-redux";
import Monnify from 'monnify-js';

import { getUserInfo } from "../../store/userData";

const useMonify = () => {
  const { amount_paid,normalPrice,isNormalPrice } = useSelector(getUserInfo);
  // const { user } = useSelector(getAuth);
  const user = JSON.parse(localStorage.getItem("user"));

  let count;
  let newValue;
      if (isNormalPrice) {
        count = 10 / 100 * normalPrice;
        newValue = normalPrice - count;
      } else {
        count = 0;
        newValue = amount_paid - count;
      }

  const monnify = new Monnify(process.env.REACT_APP_MONNIFY_API_KEY, process.env.REACT_APP_MONNIFY_CONTRACT_CODE);


  const initializePayment = (onSuccess, onClose) => {
    monnify.initializePayment({
      amount: newValue,
      currency: 'NGN',
      reference: new Date().getTime().toString(),
      customerFullName: user ? `${user.firstName} ${user.lastName}` : '',
      customerEmail: user && user.email,
      paymentDescription: 'Wellness Plan Payment',
      onComplete: onSuccess,
      onClose: onClose,
    });
  };

  return initializePayment;
};

export default useMonify;
